import React from 'react';
import { window, utils } from 'pro-gallery-lib';
class GalleryDebugMessage extends React.Component {
    render() {
        if (utils.getTopUrlParam('pgdebug') !== 'true') {
            return false;
        }
        const version = React.createElement("div", { className: "version-header " },
            "Pro Gallery Version #",
            window.staticsVersion);
        let parentSize = '';
        try {
            parentSize =
                ' psw' +
                    window.top.screen.width +
                    ' piw' +
                    window.top.innerWidth +
                    ' pbw' +
                    window.top.document.body.clientWidth;
        }
        catch (e) {
            //not on the domain
        }
        const debugMsg = (React.createElement("div", { className: "version-header " },
            utils.isLandscape() ? 'land' : 'port',
            " sw",
            window.screen.width,
            "sh",
            window.screen.height,
            " iw",
            window.innerWidth,
            " bw",
            window.document.body.clientWidth,
            " sr",
            '1',
            "rc",
            this.props.resizeCount,
            " oc",
            this.props.orientationCount,
            " nh",
            this.props.newHeight,
            " lh",
            this.props.lastHeight,
            parentSize,
            "www",
            this.props.maxGalleryWidth));
        return (React.createElement("div", null,
            version,
            debugMsg));
    }
}
export default GalleryDebugMessage;
//# sourceMappingURL=galleryDebugMessage.js.map